// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__9tUGm","projectsTitle":"Projects_projectsTitle__By5ee"};